import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from "react";
import Logo from "../Assets/images/fav-icon.png";
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../global";
import JSZip from "jszip";

import { PDFDocument } from "pdf-lib";
import { UNSAFE_NavigationContext } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import TypingEffect from "../Analysis/TypingEffect";

const UploadSteps = React.memo(
  ({
    isVisible,
    step,
    messagesTyping,
    onComplete,
    nextStep,
    setStep,
    activateTransition,
    getFirstLetter,
    handleRomove,
    fileName,
    selectedFiles,
    uploadAgents,
    serviceData,
    setUploadAgents,
    toggleSummaryAgent,
    toggleAssistantAgent,
    toggleAdditionalFeatures,
    handleFileInputChange,
    handleUpload,
    MAX_FILE_SIZE_MB,
    MAX_PDF_PAGES,
    uploadProgress,
    isUploading,
    removingFileIndex,
    agentPrompts,
    setAgentPrompts,
    isloading,
    isvalidating,
    dateOfInjury,
    setDateOfInjury,
  }) => {
    const [showAdditionalPrompt, setShowAdditionalPrompt] = useState(false);
    const [selectedPromptAgent, setSelectedPromptAgent] = useState(null);
    const [currentPrompt, setCurrentPrompt] = useState("");
    // const [agentPrompts, setAgentPrompts] = useState({});
    const [editPromptInfo, setEditPromptInfo] = useState({
      agentId: null,
      index: null,
    });

    // const agentsWithoutPrompts = uploadAgents.summary_agents.filter(
    //   (agentId) => !agentPrompts[agentId] || agentPrompts[agentId].length === 0
    // );
    const selectedService = serviceData.find(
      (service) => service.serviceId === uploadAgents.service_id,
    );

    let agentsWithoutPrompts = [];

    if (selectedService) {
      const summaryAgents = selectedService.summaryAgents || [];
      agentsWithoutPrompts = uploadAgents.summary_agents.filter((agentId) => {
        const agent = summaryAgents.find((a) => a.agentSummaryId === agentId);
        return (
          agent &&
          agent.summaryUserPromptEnable === 1 &&
          (!agentPrompts[agentId] || agentPrompts[agentId].length === 0)
        );
      });
    }
    const scrollRef = useRef(null);
    // Scroll when step or messagesTyping changes
    useEffect(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }, [step, messagesTyping]);

    const handleAutoSelectAgent = () => {
      console.log("test");
      const selectedService = serviceData?.find(
        (service) => service.serviceId == uploadAgents.service_id,
      );

      if (selectedService && Array.isArray(selectedService.assistantAgents)) {
        const agents = selectedService.assistantAgents.filter(
          (agent) => agent.agentAssistantId > 0,
        );

        // 🟢 Only auto-select if there is exactly ONE agent
        if (agents.length === 1) {
          const onlyAgent = agents[0];
          if (
            !uploadAgents.assistant_agents.includes(onlyAgent.agentAssistantId)
          ) {
            toggleAssistantAgent(onlyAgent.agentAssistantId);
          }
        }
      }
    };

    if (!isVisible) return null; // hide content but keep component mounted
    return (
      <>
        {step >= 0 && (
          <>
            {isvalidating ? (
              <>
                <Spinner
                  className="custom-spinner mt-2 mx-auto mb-1"
                  animation="border"
                  role="status"
                />
                <p>Validating...</p>
              </>
            ) : isUploading ? (
              <div className="file-upload-area w-100 d-flex justify-content-center align-items-center">
                <div className="upload-progress-container mt-2">
                  <div
                    className="progress"
                    style={{ width: "100%", height: "13px" }}
                  >
                    <div
                      className="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style={{ width: `${uploadProgress}%`, height: "10px" }}
                      aria-valuenow={uploadProgress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {uploadProgress}%
                    </div>
                  </div>
                  <p>Uploading... {uploadProgress}%</p>
                </div>
              </div>
            ) : (
              <div className="file-upload-area w-100 d-flex justify-content-center align-items-center">
                <label
                  htmlFor="file-upload-btn"
                  className="upload-icon d-flex flex-column align-items-center"
                >
                  <i className="fa-solid fa-arrow-up-from-bracket"></i>
                  <h5 className="my-1">
                    Upload your{" "}
                    {localStorage.getItem("userdocumentlabel")
                      ? `${localStorage.getItem("userdocumentlabel").toLowerCase() || "project"}`
                      : "project"}{" "}
                    here
                  </h5>
                  <a className="fs-6">Browse files</a>
                  <p className="fs-6 mt-2 mb-0">
                    {" "}
                    Kindly ensure that your PDF or ZIP file does not exceed{" "}
                    <span className="fw-semibold">{MAX_FILE_SIZE_MB}</span>
                    <br className="d-none d-lg-block" /> in size, You can add
                    multiple files.
                  </p>
                </label>
                <input
                  type="file"
                  id="file-upload-btn"
                  className="file-input"
                  accept="application/pdf, application/zip, application/x-zip-compressed"
                  onChange={handleFileInputChange}
                  multiple
                />
              </div>
            )}

            {/* <div className="d-flex justify-content-between"><div className="text-end p-2" style={{ margin: 0, fontSize: 'smaller' }}>
            *Kindly ensure that your PDF or ZIP file does not exceed {MAX_FILE_SIZE_MB} MB in size, You can add multiple files

          </div>
          </div> */}
            <div
              className={`file-upload-ctn   ${activateTransition ? "active" : ""}`}
              id="uploadedFileSection"
              style={{ height: "auto" }}
            >
              <div className="d-flex justify-content-start gap-1 mt-2">
                <div
                  className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="Profile"
                >
                  {getFirstLetter("AttestaAI")}
                </div>
                <div className="uploaded-files-container">
                  {selectedFiles && selectedFiles.length > 0
                    ? selectedFiles.map((file, idx) => (
                        <div
                          key={idx}
                          className="uploaded-file-card d-flex align-items-center"
                          style={{
                            opacity: removingFileIndex === idx ? 0.5 : 1,
                          }}
                        >
                          {removingFileIndex === idx && (
                            <div
                              className="file-loader position-absolute top-0 start-0 end-0 bottom-0 d-flex justify-content-center align-items-center"
                              style={{
                                backgroundColor: "rgba(255, 255, 255, 0.7)",
                                zIndex: 10,
                              }}
                            >
                              <div
                                className="spinner-border text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          )}
                          <div
                            className="file-close-btn"
                            onClick={() => handleRomove(idx, file.fileName)}
                            style={{
                              pointerEvents:
                                removingFileIndex === idx ? "none" : "auto", // Disable button during removal
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 640 640"
                              width="14"
                              height="14"
                              fill="#fff"
                            >
                              {" "}
                              <path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" />
                            </svg>
                          </div>
                          <div className="d-flex align-items-center">
                            <div className="uploaded-file-icon me-2">
                              <i className="fa-solid fa-file"></i>
                            </div>
                            <div className="file-name">{file.fileName}</div>
                          </div>
                        </div>
                      ))
                    : ""}
                </div>
              </div>

              {/* Summary Option */}
              <div className="d-flex justify-content-start gap-1 mt-2">
                {/* <div
                className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Profile"
              >
                {getFirstLetter(localStorage.getItem("username"))}
              </div> */}
                <div
                  className="uploaded-files position-relative"
                  style={{ border: "unset", marginLeft: "30px" }}
                >
                  {step === 0 && messagesTyping === true ? (
                    <TypingEffect
                      key={"step-1"}
                      text={` <p class="mb-1">Thank you for uploading files.</p> <div class='d-flex gap-1'><div class="upload-box"><p class="mb-0"> You have total pages: ${uploadAgents.page_count} </div> <div class="upload-box"><p>Total credits required: ${uploadAgents.cost}</p></div></div>`}
                      speed={25}
                      onComplete={() => onComplete(step)}
                    />
                  ) : (
                    <>
                      <p className="mb-1">
                        Thank you for uploading{" "}
                        {fileName ? (
                          <span class="text-primary">{fileName}</span>
                        ) : (
                          "files"
                        )}
                        .
                      </p>{" "}
                      <div class="d-flex gap-1">
                        <div class="upload-box">
                          {" "}
                          <p className="m-0">
                            You have total pages: {uploadAgents.page_count}{" "}
                          </p>
                        </div>{" "}
                        <div class="upload-box">
                          <p>Total credits required: {uploadAgents.cost}</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {step === 0 ? (
                <div className="d-flex  justify-content-end">
                  <button
                    className="btn common-btn d-flex justify-content-center align-items-center h-100 custom-file-button"
                    onClick={() => {
                      nextStep();
                    }}
                    disabled={
                      !uploadAgents.page_count ||
                      !uploadAgents.cost ||
                      isUploading
                    }
                  >
                    <h4 className="mb-0 me-1 fs-5 fw-normal">
                      Continue <i className="fa-solid fa-arrow-right"></i>
                    </h4>
                  </button>
                </div>
              ) : null}
            </div>
          </>
        )}
        {step >= 1 && (
          <div
            className={`file-upload-ctn ${activateTransition ? "active" : ""}`}
            id="uploadedFileSection"
            style={{ height: "auto", marginTop: "2px" }}
          >
            {/* First row: Profile Picture and Text */}
            <div className="d-flex justify-content-start gap-2 mt-2">
              <div
                className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Profile"
              >
                {getFirstLetter("AttestaAI")}{" "}
                {/* Display first letter of 'AttestaAI' */}
              </div>
              <div>
                {/* Conditional rendering for typing effect or static text */}
                {step === 1 && messagesTyping === true ? (
                  <TypingEffect
                    key={"step-2"}
                    text={`<p>Please enter file name:</p>`}
                    speed={25}
                    onComplete={() => onComplete(step)}
                  />
                ) : (
                  <p className="mt-1">Please enter file name:</p>
                )}
              </div>
            </div>

            {step === 1 && messagesTyping === true ? null : (
              <div className="row mt-0 ms-4">
                <div className="col-12 ps-0">
                  <input
                    type="text"
                    id="file-name-input"
                    className="form-control"
                    placeholder="Type a name for the file"
                    value={uploadAgents.file_name || ""}
                    onChange={(e) => {
                      setUploadAgents((prev) => ({
                        ...prev,
                        file_name: e.target.value,
                      }));
                    }}
                    onClick={() => {
                      setUploadAgents((prev) => ({
                        ...prev,
                        service_id: null,
                        summary_agents: [],
                        assistant_agents: [],
                      }));
                      (setCurrentPrompt(""),
                        setSelectedPromptAgent(null),
                        setShowAdditionalPrompt(false),
                        setAgentPrompts({}));
                      setStep(1);
                    }}
                  />
                </div>
              </div>
            )}
            {step === 1 && messagesTyping === false ? (
              <div className="row mt-2 ms-4">
                <div className="col-12 ps-0">
                  <label className="form-label mb-1">Enter the date of injury:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={dateOfInjury || ""}
                    onChange={(e) => setDateOfInjury(e.target.value)}
                    placeholder="DD/MM/YYYY"
                  />
                </div>
              </div>
            ) : null}
            {step === 1 ? (
              <div className="d-flex justify-content-end mt-2">
                <button
                  className="btn common-btn d-flex justify-content-center align-items-center h-100 custom-file-button"
                  onClick={() => {
                    if (
                      uploadAgents.file_name ||
                      !uploadAgents.file_name.trim() === ""
                    ) {
                      nextStep();
                    } else {
                      toast.warn("Please give the file name.");
                    }
                  }}
                  disabled={isUploading}
                >
                  <h4 className="mb-0 me-1 fs-5 fw-normal">
                    Continue <i className="fa-solid fa-arrow-right"></i>
                  </h4>
                </button>
              </div>
            ) : null}
          </div>
        )}
        {step >= 2 && (
          <div
            className={`file-upload-ctn  ${activateTransition ? "active" : ""}`}
            id="uploadedFileSection"
            style={{ height: "auto", marginTop: "2px" }}
          >
            <div className="d-flex justify-content-start gap-1 mt-2">
              <div
                className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Profile"
              >
                {getFirstLetter("AttestaAI")}
              </div>
              {step === 2 && messagesTyping === true ? (
                <TypingEffect
                  key={"step-2"}
                  text={` <p>Please select the role:</p>`}
                  speed={25}
                  onComplete={() => onComplete(step)}
                />
              ) : (
                <p>Please select the role:</p>
              )}
            </div>

            {step >= 3 || (step >= 2 && messagesTyping === false) ? (
              <div className="d-flex justify-content-start gap-1 ">
                {/* <div
              className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Profile"
            >
              {getFirstLetter('AttestaAI')}
            </div> */}

                <div className="job-selection w-100">
                  <div class="mb-0 w-100 ">
                    <div
                      class=""
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(175px, 175px))",
                        padding: "5px",
                        width: "100%",
                        justifyContent: "start",
                        marginLeft: "30px",
                      }}
                    >
                      {serviceData?.map((item) => {
                        if (item.serviceStatus === 1) {
                          const isSelected =
                            uploadAgents.service_id == item.serviceId;
                          return (
                            <a
                              className={`avatar-items ${isSelected ? "active position-relative" : "position-relative"}`}
                              key={`services` + item.serviceId}
                              onClick={() => {
                                setUploadAgents((prev) => ({
                                  ...prev,
                                  service_id: item.serviceId,
                                  summary_agents: [],
                                  assistant_agents: [],
                                }));
                                setStep(2);
                              }}
                              style={{
                                width: "90%",
                                padding: "5px",
                                margin: "5px",
                                cursor: "pointer",
                              }}
                            >
                              <div
                                className="text-center"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  alignContent: "center",
                                }}
                              >
                                <img
                                  src={item.serviceImage}
                                  alt=""
                                  style={{ width: "50px", height: "50px" }}
                                />
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.serviceDescription,
                                  }}
                                  className="text-black"
                                ></div>
                              </div>
                              <div
                                className={`${isSelected ? "selected" : ""}`}
                              >
                                {isSelected ? (
                                  <i className="fa-solid fa-check"></i>
                                ) : null}
                              </div>
                            </a>
                          );
                        } else {
                          return (
                            <a
                              className="avatar-items disable position-relative"
                              style={{
                                width: "90%",
                                padding: "5px",
                                margin: "5px",
                                cursor: "pointer",
                              }}
                            >
                              <div className="ribbon-cust">
                                <span className="ribbon-text text-white text-center">
                                  Comming Soon
                                </span>
                              </div>
                              <div
                                className="text-center"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  alignContent: "center",
                                }}
                              >
                                <img
                                  src={item.serviceImage}
                                  alt=""
                                  style={{ width: "50px", height: "50px" }}
                                />
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.serviceDescription,
                                  }}
                                  className="text-black"
                                ></div>
                              </div>
                            </a>
                          );
                        }
                      })}

                      {/* <a class="avatar-items disable" style={{ width: '90%', padding: '5px', margin: '5px' }}>
                        <div class="text-center d-flex flex-column justify-content-center h-100">
                          <h6 class="mb-0 text-muted" style={{ fontWeight: 500, fontSize: '18px', color: '#333' }}>  More to be <br /> Revealed Soon</h6>
                        </div>
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {step === 2 && messagesTyping === false ? (
              <div className="d-flex  justify-content-end">
                <button
                  className="btn common-btn d-flex justify-content-center align-items-center h-100 custom-file-button"
                  onClick={() => {
                    if (uploadAgents.service_id) {
                      nextStep();
                    } else {
                      toast.warn("Please choose at least one role.");
                    }
                  }}
                  disabled={isUploading}
                  // disabled={!uploadAgents.service_id}
                >
                  <h4 className="mb-0 me-1 fs-5 fw-normal">
                    Continue <i className="fa-solid fa-arrow-right"></i>
                  </h4>
                </button>
              </div>
            ) : null}
          </div>
        )}
        {step >= 3 && (
          <div
            className={`file-upload-ctn  ${activateTransition ? "active" : ""}`}
            id="uploadedFileSection"
            style={{ height: "auto", marginTop: "2px" }}
          >
            <div className="d-flex justify-content-start gap-1 mt-2">
              <div
                className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Profile"
              >
                {getFirstLetter("AttestaAI")}
              </div>
              {step === 3 && messagesTyping === true ? (
                <TypingEffect
                  key={"step-3"}
                  text={` <p>Select the AttestaAI agents:</p>`}
                  speed={25}
                  onComplete={() => onComplete(step)}
                />
              ) : (
                <p> Select the AttestaAI agents:</p>
              )}
            </div>

            {step >= 4 || (step === 3 && messagesTyping === false) ? (
              <div className="d-flex justify-content-start gap-1 ">
                <div className="job-selection  w-100">
                  <div class="mb-0 w-100 ">
                    <div
                      class=""
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(175px, 175px))",
                        padding: "5px",
                        width: "100%",
                        justifyContent: "start",
                        marginLeft: "30px",
                      }}
                    >
                      {serviceData
                        ?.filter(
                          (service) =>
                            service.serviceId == uploadAgents.service_id,
                        )
                        .flatMap((service) =>
                          service.summaryAgents.map((item) => {
                            const isSelected =
                              uploadAgents.summary_agents.includes?.(
                                item.agentSummaryId,
                              );

                            if (item.agentSummaryId > 0) {
                              return (
                                <a
                                  className={`avatar-items ${isSelected ? "active position-relative" : "position-relative"}`}
                                  key={`summary${item.agentSummaryId}`}
                                  onClick={() => {
                                    toggleSummaryAgent(item.agentSummaryId);
                                    setSelectedPromptAgent(null);
                                    setCurrentPrompt(null);
                                    setStep(3);
                                  }}
                                  style={{
                                    width: "90%",
                                    padding: "5px",
                                    margin: "5px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      alignContent: "center",
                                      gap: "7px",
                                    }}
                                  >
                                    {/* <img
                                      src={item.summaryPmtImg}
                                      alt=""
                                      style={{ width: '50px', height: '50px' }}
                                    /> */}
                                    <div className="">
                                      <span
                                        className="custom-icon-doc me-1"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            item?.summaryPmtIcon ||
                                            '<i class="fa-solid fa-brain"></i>',
                                        }}
                                      ></span>
                                    </div>
                                    <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                      {/* <h5 className="mb-1">{item.summaryPmtLabel}</h5> */}
                                      {/* <h5 className="mb-1">{item.summaryPmtName}</h5> */}
                                      <p className="mb-0">
                                        {" "}
                                        {item.summaryPmtLabel}
                                      </p>
                                    </div>
                                    {/* <div
                                      dangerouslySetInnerHTML={{ __html: item.serviceDescription }}
                                      className="text-black"
                                    ></div> */}
                                  </div>
                                  <div
                                    className={`${isSelected ? "selected" : ""}`}
                                  >
                                    {isSelected ? (
                                      <i className="fa-solid fa-check"></i>
                                    ) : null}
                                  </div>
                                </a>
                              );
                            } else {
                              return (
                                <a
                                  className="avatar-items disable position-relative"
                                  key={`summary${item.agentSummaryId}`}
                                  style={{
                                    width: "90%",
                                    padding: "5px",
                                    margin: "5px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div className="ribbon-cust">
                                    <span className="ribbon-text text-white text-center">
                                      Coming Soon
                                    </span>
                                  </div>
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      alignContent: "center",
                                    }}
                                  >
                                    <img
                                      src={item.summaryPmtImg}
                                      alt=""
                                      style={{ width: "50px", height: "50px" }}
                                    />
                                    <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                      <h5 className="mb-1">
                                        {item.summaryPmtName}
                                      </h5>
                                      <p className="mb-0">
                                        {" "}
                                        {item.summaryPmtLabel}
                                      </p>
                                    </div>
                                    {/* <div
                                      dangerouslySetInnerHTML={{ __html: item.serviceDescription }}
                                      className="text-black"
                                    ></div> */}
                                  </div>
                                </a>
                              );
                            }
                          }),
                        )}

                      {/* <a class="avatar-items disable" style={{ width: '90%', padding: '5px', margin: '5px' }}>
                        <div class="text-center d-flex flex-column justify-content-center h-100">
                          <h6 class="mb-0 text-muted" style={{ fontWeight: 500, fontSize: '18px', color: '#333' }}>  More to be <br /> Revealed Soon</h6>
                        </div>
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {showAdditionalPrompt && (
              <div className="mt-3 ms-4">
                {/* Saved prompts */}
                {Object.entries(agentPrompts).map(([agentId, prompts]) => {
                  const agent = serviceData
                    ?.find((s) => s.serviceId === uploadAgents.service_id)
                    ?.summaryAgents.find(
                      (a) => a.agentSummaryId === parseInt(agentId),
                    );

                  return (
                    <div
                      key={agentId}
                      className="mb-3 p-2 border rounded bg-light d-flex flex-column"
                    >
                      <p className="d-block mb-2">
                        {agent?.summaryPmtLabel} Instruction
                      </p>

                      {prompts.map((prompt, index) => (
                        <div
                          key={index}
                          className="d-flex justify-content-between align-items-start mb-1"
                        >
                          <textarea
                            className="form-control me-2"
                            rows={2}
                            value={prompt}
                            readOnly={
                              !(
                                editPromptInfo.agentId === agentId &&
                                editPromptInfo.index === index
                              )
                            }
                            onChange={(e) =>
                              setAgentPrompts((prev) => {
                                const updated = { ...prev };
                                updated[agentId][index] = e.target.value;
                                return updated;
                              })
                            }
                          />
                          <div className="d-flex flex-column">
                            {editPromptInfo.agentId === agentId &&
                            editPromptInfo.index === index ? (
                              <i
                                className="fas fa-save text-success mb-2"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "1.2rem",
                                }}
                                title="Save"
                                onClick={() =>
                                  setEditPromptInfo({
                                    agentId: null,
                                    index: null,
                                  })
                                }
                              />
                            ) : (
                              <i
                                className="fas fa-edit text-warning mb-2"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "1.2rem",
                                }}
                                title="Edit"
                                onClick={() =>
                                  setEditPromptInfo({ agentId, index })
                                }
                              />
                            )}
                            <i
                              className="fas fa-trash text-danger"
                              style={{ cursor: "pointer", fontSize: "1.2rem" }}
                              title="Delete"
                              onClick={() => {
                                setAgentPrompts((prev) => {
                                  const updated = { ...prev };
                                  if (updated[agentId].length === 1) {
                                    delete updated[agentId];
                                  } else {
                                    updated[agentId].splice(index, 1);
                                  }
                                  return updated;
                                });
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })}
                {agentsWithoutPrompts.length > 0 && (
                  <>
                    <h6>Instruct AI Agents</h6>
                    <select
                      className="form-select mb-2"
                      value={selectedPromptAgent || ""}
                      onChange={(e) => {
                        setSelectedPromptAgent(e.target.value);
                        setStep(3);
                      }}
                    >
                      <option value="" disabled>
                        Select Agent
                      </option>
                      {uploadAgents.summary_agents
                        .filter((agentId) => {
                          const selectedService = serviceData.find(
                            (s) => s.serviceId === uploadAgents.service_id,
                          );
                          const agent = selectedService?.summaryAgents.find(
                            (a) => a.agentSummaryId === agentId,
                          );

                          return (
                            !agentPrompts[agentId] &&
                            agent?.summaryUserPromptEnable === 1
                          );
                        })
                        .map((agentId) => {
                          const agent = serviceData
                            ?.find(
                              (s) => s.serviceId === uploadAgents.service_id,
                            )
                            ?.summaryAgents.find(
                              (a) => a.agentSummaryId === agentId,
                            );

                          return (
                            <option key={agentId} value={agentId}>
                              {agent?.summaryPmtLabel}
                            </option>
                          );
                        })}
                    </select>
                  </>
                )}

                {/* Textarea for new prompt */}
                {selectedPromptAgent && (
                  <div className="mb-2">
                    <label className="form-label">
                      {
                        serviceData
                          ?.find((s) => s.serviceId == uploadAgents.service_id)
                          ?.summaryAgents.find(
                            (a) => a.agentSummaryId == selectedPromptAgent,
                          )?.summaryPmtLabel
                      }
                    </label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={currentPrompt}
                      onChange={(e) => setCurrentPrompt(e.target.value)}
                      placeholder="Instruct AI agent..."
                    />
                    <button
                      className="btn btn-secondary mt-2 me-2"
                      onClick={() => {
                        setCurrentPrompt("");
                        setSelectedPromptAgent("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary mt-2"
                      onClick={() => {
                        if (!currentPrompt.trim()) return;

                        setAgentPrompts((prev) => ({
                          ...prev,
                          [selectedPromptAgent]: [currentPrompt],
                        }));

                        setCurrentPrompt("");
                        setSelectedPromptAgent(null);
                      }}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            )}

            {step === 3 && messagesTyping === false ? (
              <div className="d-flex  justify-content-end gap-1">
                {/* {!showAdditionalPrompt && uploadAgents.summary_agents?.length > 0 && (
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => setShowAdditionalPrompt(true)}
                  >
                    Add Prompt
                  </button>
                )} */}
                {(() => {
                  const selectedService = serviceData.find(
                    (s) => s.serviceId === uploadAgents.service_id,
                  );

                  const summaryAgents = selectedService?.summaryAgents || [];

                  const hasPromptEnabledAgent =
                    uploadAgents.summary_agents?.some((agentId) => {
                      const agent = summaryAgents.find(
                        (a) => a.agentSummaryId === agentId,
                      );
                      return agent && agent.summaryUserPromptEnable === 1;
                    });

                  return (
                    !showAdditionalPrompt &&
                    hasPromptEnabledAgent && (
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => setShowAdditionalPrompt(true)}
                      >
                        Instruct AI Agents
                      </button>
                    )
                  );
                })()}

                <button
                  className="btn common-btn d-flex justify-content-center align-items-center h-100 custom-file-button"
                  onClick={() => {
                    if (uploadAgents.summary_agents?.length > 0) {
                      nextStep();
                      handleAutoSelectAgent();
                      setSelectedPromptAgent(null);
                      // setShowAdditionalPrompt(false);
                    } else {
                      toast.warn("Please select at least one AttestaAI agent.");
                    }
                  }}
                  disabled={isUploading}
                >
                  <h4 className="mb-0 me-1 fs-5 fw-normal">
                    Continue <i className="fa-solid fa-arrow-right"></i>
                  </h4>
                </button>
              </div>
            ) : null}
          </div>
        )}
        {step >= 4 && (
          <div
            className={`file-upload-ctn ${activateTransition ? "active" : ""}`}
            id="uploadedFileSection"
            style={{ height: "auto", marginTop: "2px" }}
          >
            <div className="d-flex justify-content-start gap-1 mt-2">
              <div
                className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Profile"
              >
                {getFirstLetter("AttestaAI")}
              </div>
              {step === 4 && messagesTyping === true ? (
                <TypingEffect
                  key={"step-4"}
                  text={`  <p>
                      ${
                        serviceData?.filter(
                          (service) =>
                            service.serviceId === uploadAgents.service_id,
                        )[0]?.assistantAgents.length === 1
                          ? "Hi, I am your agent"
                          : "Hi, we are your agents"
                      }! 
                    ${
                      serviceData?.filter(
                        (service) =>
                          service.serviceId === uploadAgents.service_id,
                      )[0]?.assistantAgents.length > 0
                        ? serviceData?.filter(
                            (service) =>
                              service.serviceId === uploadAgents.service_id,
                          )[0]?.assistantAgents.length === 1
                          ? " Would you like us to assist you?"
                          : " Would any of us like to assist you?"
                        : "Hi, we are your agents! Would any of us like to assist you?"
                    }
                    </p>`}
                  speed={10}
                  onComplete={() => onComplete(step)}
                />
              ) : (
                <p>
                  {serviceData?.filter(
                    (service) => service.serviceId === uploadAgents.service_id,
                  )[0]?.assistantAgents.length === 1
                    ? "Hi, I am your agent"
                    : "Hi, we are your agents"}
                  !
                  {serviceData?.filter(
                    (service) => service.serviceId === uploadAgents.service_id,
                  )[0]?.assistantAgents.length > 0
                    ? serviceData?.filter(
                        (service) =>
                          service.serviceId === uploadAgents.service_id,
                      )[0]?.assistantAgents.length === 1
                      ? " Would you like us to assist you?"
                      : " Would any of us like to assist you?"
                    : "Hi, we are your agents! Would any of us like to assist you?"}
                </p>
              )}
            </div>
            {step >= 5 || (step === 4 && messagesTyping === false) ? (
              <div className="d-flex justify-content-start gap-1 ">
                <div className="job-selection w-100">
                  <div class="mb-0 w-100 ">
                    <div
                      class=""
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(175px, 175px))",
                        padding: "5px",
                        width: "100%",
                        justifyContent: "start",
                        marginLeft: "30px",
                      }}
                    >
                      {serviceData
                        ?.filter(
                          (service) =>
                            service.serviceId == uploadAgents.service_id,
                        )
                        .flatMap((service) =>
                          service.assistantAgents.map((item) => {
                            const isSelected =
                              uploadAgents.assistant_agents.includes?.(
                                item.agentAssistantId,
                              );

                            if (item.agentAssistantId > 0) {
                              return (
                                <a
                                  className={`avatar-items ${isSelected ? "active position-relative" : "position-relative"}`}
                                  key={`assistant${item.agentAssistantId}`}
                                  onClick={() => {
                                    toggleAssistantAgent(item.agentAssistantId);
                                  }}
                                  style={{
                                    width: "90%",
                                    padding: "5px",
                                    margin: "5px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      alignContent: "center",
                                    }}
                                  >
                                    <img
                                      src={item.assistantImg}
                                      alt=""
                                      style={{ width: "50px", height: "50px" }}
                                    />
                                    <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                      <h5 className="mb-1">
                                        {item.assistantName}
                                      </h5>
                                      <p className="mb-0">
                                        {" "}
                                        {item.assistantLabel}
                                      </p>
                                    </div>
                                    {/* <div
                                      dangerouslySetInnerHTML={{ __html: item.serviceDescription }}
                                      className="text-black"
                                    ></div> */}
                                  </div>
                                  <div
                                    className={`${isSelected ? "selected" : ""}`}
                                  >
                                    {isSelected ? (
                                      <i className="fa-solid fa-check"></i>
                                    ) : null}
                                  </div>
                                </a>
                              );
                            } else {
                              return (
                                <a
                                  className="avatar-items disable position-relative"
                                  key={`summary${item.agentSummaryId}`}
                                  style={{
                                    width: "90%",
                                    padding: "5px",
                                    margin: "5px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div className="ribbon-cust">
                                    <span className="ribbon-text text-white text-center">
                                      Coming Soon
                                    </span>
                                  </div>
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      alignContent: "center",
                                    }}
                                  >
                                    <img
                                      src={item.summaryPmtImg}
                                      alt=""
                                      style={{ width: "50px", height: "50px" }}
                                    />
                                    <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                      <h5 className="mb-1">
                                        {item.summaryPmtName}
                                      </h5>
                                      <p className="mb-0">
                                        {" "}
                                        {item.summaryPmtLabel}
                                      </p>
                                    </div>
                                    {/* <div
                                      dangerouslySetInnerHTML={{ __html: item.serviceDescription }}
                                      className="text-black"
                                    ></div> */}
                                  </div>
                                </a>
                              );
                            }
                          }),
                        )}

                      {/* <a class="avatar-items disable" style={{ width: '90%', padding: '5px', margin: '5px' }}>
                        <div class="text-center d-flex flex-column justify-content-center h-100">
                          <h6 class="mb-0 text-muted" style={{ fontWeight: 500, fontSize: '18px', color: '#333' }}>  More to be <br /> Revealed Soon</h6>
                        </div>
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {step === 4 && messagesTyping === false ? (
              <div className="d-flex  justify-content-end gap-1">
                <button
                  className="btn common-btn d-flex justify-content-center align-items-center h-100 custom-file-button"
                  onClick={() => {
                    if (uploadAgents.assistant_agents?.length > 0) {
                      // nextStep();
                      const selectedService = serviceData?.find(
                        (service) =>
                          service.serviceId == uploadAgents.service_id,
                      );

                      const hasAdditionalFeatures =
                        selectedService?.appsFeature?.some(
                          (item) => item.commonAppId > 0,
                        ) || false;

                      if (hasAdditionalFeatures) {
                        nextStep();
                      } else {
                        handleUpload();
                      }
                    } else {
                      toast.warn(
                        "Please select at least one AttestaAI assistant.",
                      );
                    }
                  }}
                  disabled={isUploading}
                >
                  <h4 className="mb-0 me-1 fs-5 fw-normal">
                    {(() => {
                      const selectedService = serviceData?.find(
                        (service) =>
                          service.serviceId == uploadAgents.service_id,
                      );

                      console.log(selectedService);
                      const hasAdditionalFeatures =
                        selectedService?.appsFeature?.some(
                          (item) => item.commonAppId > 0,
                        ) || false;

                      return hasAdditionalFeatures ? "Continue" : "Submit";
                    })()}{" "}
                    <i className="fa-solid fa-arrow-right"></i>
                  </h4>
                </button>
              </div>
            ) : null}
          </div>
        )}
        {step >= 5 && (
          <div
            className={`file-upload-ctn ${activateTransition ? "active" : ""}`}
            id="uploadedFileSection"
            style={{ height: "auto", marginTop: "2px" }}
          >
            <div className="d-flex justify-content-start gap-1 mt-2">
              <div
                className="profile-dp rounded-circle d-flex justify-content-center align-items-center"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Profile"
              >
                {getFirstLetter("AttestaAI")}
              </div>
              {step === 5 && messagesTyping === true ? (
                <TypingEffect
                  key={"step-3"}
                  text={` <p>Select the additional AttestaAI agents:</p>`}
                  speed={25}
                  onComplete={() => onComplete(step)}
                />
              ) : (
                <p>Select the additional AttestaAI agents:</p>
              )}
            </div>
            {step >= 5 && messagesTyping === false ? (
              <div className="d-flex justify-content-start gap-1 ">
                <div className="job-selection w-100">
                  <div class="mb-0 w-100 ">
                    <div
                      class=""
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(175px, 175px))",
                        padding: "5px",
                        width: "100%",
                        justifyContent: "start",
                        marginLeft: "30px",
                      }}
                    >
                      {serviceData
                        ?.filter(
                          (service) =>
                            service.serviceId == uploadAgents.service_id,
                        )
                        .flatMap((service) =>
                          service.appsFeature.map((item) => {
                            const isSelected =
                              uploadAgents.apps_Feature.includes?.(
                                item.commonAppId,
                              );

                            if (item.commonAppId > 0) {
                              return (
                                <a
                                  className={`avatar-items ${isSelected ? "active position-relative" : "position-relative"}`}
                                  key={`assistant${item.commonAppId}`}
                                  onClick={() => {
                                    toggleAdditionalFeatures(item.commonAppId);
                                  }}
                                  style={{
                                    width: "90%",
                                    padding: "5px",
                                    margin: "5px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      alignContent: "center",
                                    }}
                                  >
                                    <div className="">
                                      <span
                                        className="custom-icon-doc me-1"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            item?.appIcon ||
                                            '<i class="fa-solid fa-brain"></i>',
                                        }}
                                      ></span>
                                    </div>
                                    <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                      <p className="mb-0"> {item.appName}</p>
                                    </div>
                                    {/* <div
                                      dangerouslySetInnerHTML={{ __html: item.serviceDescription }}
                                      className="text-black"
                                    ></div> */}
                                  </div>
                                  <div
                                    className={`${isSelected ? "selected" : ""}`}
                                  >
                                    {isSelected ? (
                                      <i className="fa-solid fa-check"></i>
                                    ) : null}
                                  </div>
                                </a>
                              );
                            } else {
                              return (
                                <a
                                  className="avatar-items disable position-relative"
                                  key={`summary${item.agentSummaryId}`}
                                  style={{
                                    width: "90%",
                                    padding: "5px",
                                    margin: "5px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div className="ribbon-cust">
                                    <span className="ribbon-text text-white text-center">
                                      Coming Soon
                                    </span>
                                  </div>
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      alignContent: "center",
                                    }}
                                  >
                                    <img
                                      src={item.summaryPmtImg}
                                      alt=""
                                      style={{ width: "50px", height: "50px" }}
                                    />
                                    <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                      <h5 className="mb-1">
                                        {item.summaryPmtName}
                                      </h5>
                                      <p className="mb-0">
                                        {" "}
                                        {item.summaryPmtLabel}
                                      </p>
                                    </div>
                                    {/* <div
                                      dangerouslySetInnerHTML={{ __html: item.serviceDescription }}
                                      className="text-black"
                                    ></div> */}
                                  </div>
                                </a>
                              );
                            }
                          }),
                        )}

                      {/* <a class="avatar-items disable" style={{ width: '90%', padding: '5px', margin: '5px' }}>
                        <div class="text-center d-flex flex-column justify-content-center h-100">
                          <h6 class="mb-0 text-muted" style={{ fontWeight: 500, fontSize: '18px', color: '#333' }}>  More to be <br /> Revealed Soon</h6>
                        </div>
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {step === 5 && messagesTyping === false ? (
              <div className="d-flex  justify-content-end">
                <button
                  className="btn common-btn d-flex justify-content-center align-items-center h-100 custom-file-button"
                  onClick={() => {
                    if (uploadAgents.assistant_agents?.length > 0) {
                      handleUpload();
                    } else {
                      toast.warn(
                        "Please select at least one AttestaAI assistant.",
                      );
                    }
                  }}
                  disabled={isloading || isUploading}
                >
                  <h4 className="mb-0 me-0 fs-5 fw-normal">
                    Submit<i className="fa-solid fa-arrow-right"></i>
                  </h4>
                </button>
              </div>
            ) : null}
          </div>
        )}

        <>
          <div ref={scrollRef} style={{ height: 1 }} />
        </>
      </>
    );
  },
);

// ✅ Hook to block in-app navigation
function useBlocker(blocker, when = true) {
  const { navigator } = useContext(UNSAFE_NavigationContext);

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;
    const replace = navigator.replace;

    navigator.push = (...args) => {
      if (blocker()) {
        push.apply(navigator, args);
      }
    };
    navigator.replace = (...args) => {
      if (blocker()) {
        replace.apply(navigator, args);
      }
    };

    return () => {
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [navigator, blocker, when]);
}

const Upload = React.memo(
  ({
    onRegisterReset,
    handleContinueClick,
    handleFileClose,
    handleFileChange,
    activateTransition,
    fileUploaded,
    fileName,
    fetchAllCases,
    tokensData,
    handleShowSettings,
    setHasUploadInProgress,
  }) => {
    const [serviceData, setServiceData] = useState([]);
    const [error, setError] = useState("");
    const [isloading, setLoading] = useState(false);
    const [removingFileIndex, setRemovingFileIndex] = useState(null);
    const [agentPrompts, setAgentPrompts] = useState({});
    const [dateOfInjury, setDateOfInjury] = useState("");
    const handleAgentPromptsChange = (updatedPrompts) => {
      setAgentPrompts(updatedPrompts);
    };
    // multi step form functionality

    const initialUploadAgents = {
      page_count: "",
      cost: "",
      file_name: "",
      service_id: "",
      summary_agents: [],
      assistant_agents: [],
      apps_Feature: [],
      temp_session_id: "",
    };

    const [uploadAgents, setUploadAgents] = useState(initialUploadAgents);

    const resetForm = () => {
      setUploadAgents(initialUploadAgents);
    };
    const resetFormmain = () => {
      setUploadAgents(initialUploadAgents);
      setSelectedFiles([]);
      setStep(0);
      setMessagesTyping(true);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setAgentPrompts({});
      setHasUploadInProgress(false);
      handleFileClose?.();

      console.log("✅ Upload state fully reset");
    };
    useEffect(() => {
      if (onRegisterReset) {
        onRegisterReset(() => resetFormmain);
      }
    }, [onRegisterReset]);

    const toggleSummaryAgent = useCallback((agentId) => {
      setUploadAgents((prev) => {
        const exists = prev.summary_agents.includes(agentId);

        return {
          ...prev,
          summary_agents: exists
            ? prev.summary_agents.filter((id) => id !== agentId) // Remove
            : [...prev.summary_agents, agentId], // Add
        };
      });

      setAgentPrompts((prevPrompts) => {
        const updatedPrompts = { ...prevPrompts };

        if (agentId in updatedPrompts) {
          delete updatedPrompts[agentId];
        }

        return updatedPrompts;
      });
    }, []);

    const toggleAssistantAgent = useCallback((agentId) => {
      setUploadAgents((prev) => {
        const exists = prev.assistant_agents.includes(agentId);

        return {
          ...prev,
          assistant_agents: exists
            ? prev.assistant_agents.filter((id) => id !== agentId) // Remove
            : [...prev.assistant_agents, agentId], // Add
        };
      });
    }, []);

    const toggleAdditionalFeatures = useCallback((agentId) => {
      setUploadAgents((prev) => {
        const exists = prev.apps_Feature.includes(agentId);

        return {
          ...prev,
          apps_Feature: exists
            ? prev.apps_Feature.filter((id) => id !== agentId) // Remove
            : [...prev.apps_Feature, agentId], // Add
        };
      });
    }, []);

    const [step, setStep] = useState(0);
    const [messagesTyping, setMessagesTyping] = useState(true);

    const onComplete = useCallback(
      (step) => {
        setMessagesTyping(false);
      },
      [setMessagesTyping],
    );
    const nextStep = useCallback(() => {
      setMessagesTyping(true);
      setStep((prev) => prev + 1);
    }, []);

    //Fetch Services Data
    useEffect(() => {
      fetchOptionsService();
    }, []);
    const fetchOptionsService = async () => {
      try {
        const response = await axios.get(API_BASE_URL + "services");
        console.log(response);
        const allService = response.data || [];

        if (allService?.message?.length > 0) {
          setServiceData(allService?.message || []);
        } else {
          setServiceData([]);
        }
      } catch (error) {
        console.error("Error fetching insights:", error);
      }
    };
    //Fetch Service Data end

    //step 1

    const MAX_FILE_SIZE_MB = 190;
    const MAX_PDF_PAGES = 1500; // example: limit to 10 pages
    const totalTokens = parseFloat(tokensData.Total_token) || 0;
    const usedTokens = parseFloat(tokensData.Used_token) || 0;
    const AVALABLE_CREDIT = Math.max(totalTokens - usedTokens, 0);
    //const AVALABLE_CREDIT = (parseFloat(tokensData.Total_token) || 0) - (parseFloat(tokensData.Used_token) || 0);

    const [fileQueue, setFileQueue] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [caseName, setCaseName] = useState("");

    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [isvalidating, setIsvalidating] = useState(false);

    const fileInputRef = useRef();

    const handleFileInputChange = async (e) => {
      try {
        setIsvalidating(true);

        const files = Array.from(e.target.files);

        const existingFileNames = selectedFiles.map((file) => file.fileName);
        const newFileNames = files.map((file) => file.name);
        const duplicateFiles = newFileNames.filter((name) =>
          existingFileNames.includes(name),
        );
        if (duplicateFiles.length > 0) {
          toast.error("The file name already exists!");
          e.target.value = "";
          setIsvalidating(false);
          return;
        }
        const file = files[0];
        const fileSize = file.size;
        const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert MB to bytes

        // if (fileSize > MAX_FILE_SIZE_BYTES) {
        //   toast.error(`The file size exceeds ${MAX_FILE_SIZE_MB} MB. Please upload a smaller file.`);
        //   e.target.value = "";
        //   setIsUploading(false);
        //   return;
        // }
        let totalSize = 0;
        for (let i = 0; i < files.length; i++) {
          totalSize += files[i].size;
        }

        if (totalSize > MAX_FILE_SIZE_BYTES) {
          toast.error(
            `The total file(s) size exceeds ${MAX_FILE_SIZE_MB} MB. Please upload smaller files.`,
          );
          e.target.value = ""; // Clear the file input
          setIsvalidating(false);
          return;
        }

        let totalPagesCount = 0;
        let allFiles = [];

        for (let file of files) {
          try {
            if (file.type === "application/pdf") {
              // PDF: calculate pages
              const arrayBuffer = await file.arrayBuffer();
              const pdfDoc = await PDFDocument.load(arrayBuffer);
              totalPagesCount += pdfDoc.getPageCount();
              allFiles.push({ file, name: file.name });
            } else if (
              file.type === "application/zip" ||
              file.type === "application/x-zip-compressed"
            ) {
              // ZIP: read PDFs inside and calculate pages
              try {
                const zip = await JSZip.loadAsync(file);
                const pdfFiles = Object.values(zip.files).filter((f) =>
                  f.name.endsWith(".pdf"),
                );
                if (zip.password) {
                  toast.error(
                    "The ZIP file is password-protected. Please upload an unprotected ZIP.",
                  );
                  e.target.value = "";
                  setIsvalidating(false);
                  return;
                }
                for (let pdfFile of pdfFiles) {
                  try {
                    const arrayBuffer = await pdfFile.async("arraybuffer");
                    const pdfDoc = await PDFDocument.load(arrayBuffer);
                    totalPagesCount += pdfDoc.getPageCount();
                    allFiles.push({ file, name: file.name });
                  } catch (err) {
                    if (
                      err.message.includes("Password") ||
                      err.message.includes("encrypted")
                    ) {
                      toast.error(
                        `The PDF file "${pdfFile.name}" is password-protected. Please upload an unprotected file.`,
                      );
                    } else {
                      toast.error("Invalid or corrupted PDF file.");
                    }
                    e.target.value = "";
                    setIsvalidating(false);
                    console.error("PDF parsing error inside ZIP:", err);
                    return;
                  }
                }
              } catch (err) {
                console.log(err.message);
                if (
                  err.message.includes("Encrypted") ||
                  err.message.includes("Password")
                ) {
                  toast.error(
                    "The ZIP file is password-protected. Please upload an unprotected ZIP.",
                  );
                } else {
                  toast.error("The ZIP file is corrupted or invalid.");
                }
                console.error("ZIP file error:", err);
                e.target.value = "";
                setIsvalidating(false);
                return;
              }
            } else {
              toast.error("Invalid or corrupted file.");
            }
          } catch (err) {
            if (
              err.message.includes("Password") ||
              err.message.includes("encrypted")
            ) {
              toast.error(
                "PDF is password-protected. Please upload an unprotected file.",
              );
            } else {
              toast.error("Invalid or corrupted PDF file.");
            }
            console.error("PDF parsing error:", err);
            e.target.value = "";
            setIsvalidating(false);
            return;
          }
        }

        const totalWithExisting =
          (uploadAgents?.page_count || 0) + totalPagesCount;

        if (totalWithExisting > AVALABLE_CREDIT) {
          toast.error(
            `Insufficient credit: available ${AVALABLE_CREDIT} page credits, but ${totalWithExisting} pages requested.`,
          );
          e.target.value = "";
          setIsvalidating(false);
          setUploadProgress(0);
          return;
        }

        setHasUploadInProgress(true);
        setIsvalidating(false);

        setIsUploading(true);

        try {
          const userid = localStorage.getItem("userid");
          const formData = new FormData();
          for (let i = 0; i < files.length; i++) {
            formData.append("file", files[i]);
          }

          formData.append("userId", userid);
          formData.append("mode", "validate");
          if (uploadAgents.temp_session_id) {
            formData.append("sessionId", uploadAgents.temp_session_id);
          }

          const response = await axios.post(
            `${API_BASE_URL}multiple_upload`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              onUploadProgress: (progressEvent) => {
                if (progressEvent.lengthComputable) {
                  const percentage = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total,
                  );
                  setUploadProgress(percentage);
                }
              },
            },
          );

          if (response.data.status === 1) {
            const responsedata = response.data.validated_data;

            setUploadAgents((prev) => ({
              ...prev,
              page_count: responsedata?.totalPages,
              cost: responsedata?.totalPages,
              temp_session_id: responsedata?.sessionId,
            }));

            setSelectedFiles(responsedata?.filesList);
            handleFileChange(e);
            setIsUploading(false);
            setUploadProgress(0);
            e.target.value = "";
          } else {
            toast.error(response.data.message || "");
          }
        } catch (err) {
          console.error("Error while uploading files:", err);
        } finally {
          setIsUploading(false);
        }

        console.log(totalPagesCount);
      } catch (error) {
        // Detect corrupted or password-protected files
        if (
          error.message.includes("Password") ||
          error.message.includes("encrypted")
        ) {
          toast.error(
            "PDF is password-protected. Please upload an unprotected file.",
          );
        } else {
          toast.error("Invalid or corrupted PDF file.");
        }
        console.error("PDF parsing error:", error);
        e.target.value = "";
      }
    };

    useEffect(() => {
      const handleBeforeUnload = (e) => {
        if (selectedFiles.length > 0) {
          e.preventDefault();
          e.returnValue =
            "You have unsaved uploads. Are you sure you want to leave?";
        }
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      return () =>
        window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [selectedFiles]);

    // ✅ Warn if navigating inside app
    // useBlocker(() => {
    //   if (selectedFiles.length > 0) {
    //     return window.confirm("You have unsaved uploads. Are you sure you want to leave?");
    //   }
    //   return true;
    // }, selectedFiles.length > 0);

    const selectedFilesRef = useRef([]);
    const fileQueueRef = useRef([]);
    const caseNameRef = useRef("");
    const uploadAgentsRef = useRef({});

    useEffect(() => {
      selectedFilesRef.current = selectedFiles;
    }, [selectedFiles]);

    useEffect(() => {
      fileQueueRef.current = fileQueue;
    }, [fileQueue]);

    useEffect(() => {
      caseNameRef.current = caseName;
    }, [caseName]);

    useEffect(() => {
      uploadAgentsRef.current = uploadAgents;
    }, [uploadAgents]);

    const handleUploadbkp3008 = useCallback(async (event) => {
      event?.preventDefault();
      setLoading(true);

      const selectedFiles = selectedFilesRef.current;
      const fileQueue = fileQueueRef.current;
      const caseName = caseNameRef.current;
      const uploadAgents = uploadAgentsRef.current;

      if (selectedFiles.length === 0) {
        toast.warn("Please select at least one file.");
        setLoading(false);
        return;
      }

      const updatedQueue = [
        ...fileQueue,
        ...selectedFiles.map((f) => ({ ...f, status: "Processing" })),
      ];
      setFileQueue(updatedQueue);

      for (let fileItem of selectedFiles) {
        const file = fileItem.file;
        const reader = new FileReader();

        reader.onload = async () => {
          const blob = new Blob([reader.result], { type: file.type });
          const nameWithoutExtension = file.name
            .split(".")
            .slice(0, -1)
            .join(".");
          const formData = new FormData();

          formData.append("pdf", blob, file.name);
          formData.append("caseName", caseName || nameWithoutExtension);
          formData.append("userId", localStorage.getItem("userid") || 0);
          formData.append("service_id", uploadAgents.service_id || null);
          (uploadAgents.summary_agents || []).forEach((id) =>
            formData.append("summary_agents[]", id),
          );
          (uploadAgents.assistant_agents || []).forEach((id) =>
            formData.append("assistant_agents[]", id),
          );

          try {
            const response = await axios.post(
              `${API_BASE_URL}upload`,
              formData,
              {
                headers: { "Content-Type": "multipart/form-data" },
              },
            );

            if (response.data.message === "Case uploaded successful") {
              setLoading(false);
              fileInputRef.current && (fileInputRef.current.value = "");
              setSelectedFiles([]);
              handleFileClose();
              fetchAllCases();

              if (response.data.case_id) {
                localStorage.setItem("caseID", response.data.case_id);
                window.dispatchEvent(new Event("caseIDUpdated"));
                localStorage.setItem(
                  "caseUploaded",
                  "Your document has been successfully uploaded!",
                );
                setTimeout(() => localStorage.removeItem("caseUploaded"), 3000);
                handleContinueClick();
              }
            } else {
              toast.error(`Upload failed: ${response.data.message}`);
              setLoading(false);
              fileInputRef.current && (fileInputRef.current.value = "");
            }
          } catch (error) {
            console.log(error);
            setLoading(false);
            fileInputRef.current && (fileInputRef.current.value = "");
            setSelectedFiles([]);
            handleFileClose();
            const message = error?.message || "An error occurred";
            toast.error(`Upload failed: ${file.name} — ${message}`);
          }
        };

        reader.onerror = () => {
          toast.error(`Failed to read ${file.name}`);
          setLoading(false);
          setFileQueue((prev) =>
            prev.map((f) =>
              f.name === file.name ? { ...f, status: "Failed" } : f,
            ),
          );
        };

        reader.readAsArrayBuffer(file);
      }
    }, []); // Empty deps works now because refs always point to latest

    const handleUpload = async (event) => {
      event?.preventDefault();
      setLoading(true);

      const formData = new FormData();
      formData.append("fileName", uploadAgents.file_name);
      formData.append("dateOfInjury", dateOfInjury || "");
      formData.append("mode", "submit");
      if (uploadAgents.temp_session_id) {
        formData.append("sessionId", uploadAgents.temp_session_id);
      }
      formData.append("userId", localStorage.getItem("userid") || 0);
      formData.append("service_id", uploadAgents.service_id || null);
      (uploadAgents.summary_agents || []).forEach((id) =>
        formData.append("summary_agents[]", id),
      );
      (uploadAgents.assistant_agents || []).forEach((id) =>
        formData.append("assistant_agents[]", id),
      );
      (uploadAgents.apps_Feature || []).forEach((id) =>
        formData.append("apps_feature[]", id),
      );
      // Object.entries(agentPrompts).forEach(([agentId, prompts]) => {
      //   prompts.forEach((prompt, index) => {
      //     //     formData.append(`additional_prompts[${agentId}][]`, prompt);
      //     formData.append(`userPrompt[${index}][userPromptDescription]`, prompt);
      //     formData.append(`userPrompt[${index}][userPromptAgentId]`, agentId);
      //   });
      // });

      const userPromptArray = [];

      Object.entries(agentPrompts).forEach(([agentId, prompts]) => {
        prompts.forEach((prompt) => {
          userPromptArray.push({
            userPromptDescription: prompt,
            userPromptAgentId: parseInt(agentId, 10),
          });
        });
      });

      // ✅ Now append as JSON string
      formData.append("userPrompt", JSON.stringify(userPromptArray));

      try {
        const response = await axios.post(
          `${API_BASE_URL}multiple_upload`,
          formData,
        );

        if (response.data.message === "Case uploaded successful") {
          setLoading(false);
          setHasUploadInProgress(false);
          fileInputRef.current && (fileInputRef.current.value = "");
          setSelectedFiles([]);
          handleFileClose();
          fetchAllCases();

          if (response.data.case_id) {
            localStorage.setItem("caseID", response.data.case_id);
            window.dispatchEvent(new Event("caseIDUpdated"));
            localStorage.setItem(
              "caseUploaded",
              "Your document has been successfully uploaded!",
            );
            setTimeout(() => localStorage.removeItem("caseUploaded"), 3000);

            handleContinueClick();
          }
        } else {
          toast.error(`Upload failed: ${response.data.message}`);
          setLoading(false);
          fileInputRef.current && (fileInputRef.current.value = "");
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        setHasUploadInProgress(false);
        fileInputRef.current && (fileInputRef.current.value = "");
        setSelectedFiles([]);
        handleFileClose();
        const message = error?.message || "An error occurred";
        toast.error(`Upload failed: ${message}`);
      }
    }; // Empty deps works now because refs always point to latest

    const handleRomove1 = useCallback((index) => {
      setSelectedFiles((prevFiles) => {
        const updatedFiles = prevFiles.filter((_, i) => i !== index);
        // If no files left, reset everything
        if (updatedFiles.length === 0) {
          if (fileInputRef.current) {
            fileInputRef.current.value = ""; // safely reset file input
          }
          handleFileClose();
          setStep(0);
          setMessagesTyping(true);
        }
        return updatedFiles;
      });
    }, []);

    const handleRomove = useCallback(
      async (index, file) => {
        try {
          setRemovingFileIndex(index);
          const userid = localStorage.getItem("userid");
          const formData = new FormData();
          formData.append("userId", userid);
          formData.append("mode", "delete");
          formData.append("file_name", file);
          if (uploadAgents.temp_session_id) {
            formData.append("sessionId", uploadAgents.temp_session_id);
          }
          const response = await axios.post(
            `${API_BASE_URL}multiple_upload`,
            formData,
          );

          if (response.data.status === 1) {
            const responsedata = response.data.validated_data;
            setUploadAgents((prev) => ({
              ...prev,
              page_count: responsedata?.totalPages,
              cost: responsedata?.totalPages,
              temp_session_id: responsedata?.sessionId,
            }));

            setSelectedFiles(responsedata?.filesList);
            if (responsedata?.filesList.length === 0) {
              if (fileInputRef.current) {
                fileInputRef.current.value = "";
              }
              setHasUploadInProgress(false);
              handleFileClose();
              setUploadAgents(initialUploadAgents);
              setStep(0);
              setMessagesTyping(true);
            }
          } else {
            toast.error(
              response?.data?.message || "Error while removing the file",
            );
          }
        } catch (err) {
          console.error("Error while removing the file:", err);
          toast.error("An error occurred while removing the file.");
        } finally {
          setRemovingFileIndex(null);
        }
      },
      [selectedFiles],
    );

    const steps = [
      "File Upload",
      "Select a Role",
      "Select AttestaAI Summary Agent",
      "Select AttestaAI Assistant",
    ];
    const getFirstLetter = useCallback((data) => {
      return data && data.trim() ? data.trim().charAt(0).toUpperCase() : "";
    }, []);

    if (isloading) {
      return (
        <div id="div2" className={`right-ctn flexible row`}>
          <div className="page-wrapper">
            {/* <!-- Page Content--> */}
            <div className="page-content d-flex flex-column w-100 align-items-center justify-content-between">
              <div className="home-one-wrapper-main position-relative">
                <div className="home-one-wrapper " style={{ maxWidth: "100%" }}>
                  {/* <!-- page content --> */}

                  <div className="home-one-wrapper-inner">
                    <div className="home-bot-chat" style={{ maxWidth: "100%" }}>
                      <div
                        className="home-one-wrapper-inner"
                        style={{ marginTop: "100px" }}
                      >
                        <div className="home-bot-chat ">
                          <div className="custome-doc-viewer-wrapper content-box-before">
                            <div className="custom-doc-viewer2 uploadLoader">
                              <div
                                className="text-start d-flex flex-column gap-2"
                                style={{ height: "100px" }}
                              >
                                <div className="d-flex flex-column">
                                  <h5 className="skeleton-line w-100">
                                    Uploading Document...
                                  </h5>
                                  <p className="mb-0">
                                    We've received your file and it's currently
                                    being processed. This may take a few
                                    minutes. We'll email you as soon as the
                                    process is complete.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div id="div2" className="right-ctn flexible">
        <div className="page-wrapper">
          <div
            className="page-content d-flex flex-column justify-content-end w-100"
            style={{ minHeight: "calc(80vh - var(--bs-topbar-height))" }}
          >
            <div className="index-inner-wrapper" style={{ display: "flex" }}>
              <div className="home-one-wrapper d-flex justify-content-start flex-column align-items-center">
                <h6 className="welNote mb-0">
                  <img
                    className="welnote-logo me-2"
                    src={Logo}
                    alt="welnote-logo"
                  />
                  Hi {localStorage.getItem("username") || "Alden"}, Ready To
                  Review Your{" "}
                  {localStorage.getItem("userdocumentlabel")
                    ? `${localStorage.getItem("userdocumentlabel")}`
                    : "Project"}
                  .
                </h6>

                <div
                  className="btm-chat-wrap text-center w-100"
                  style={{ maxWidth: "100%" }}
                >
                  <div className="chat-bot-wrapper w-100 h-100 d-flex justify-content-center align-items-center">
                    <div
                      className="chat-bot-inner  w-100 h-100 flex-column"
                      style={{
                        display:
                          fileUploaded && selectedFiles ? "block" : "flex",
                      }}
                    >
                      {!fileUploaded && (
                        <>
                          {isvalidating ? (
                            <>
                              <Spinner
                                className="custom-spinner mt-2 mx-auto mb-1"
                                animation="border"
                                role="status"
                              />
                              <p>Validating...</p>
                            </>
                          ) : (
                            <>
                              <div className="file-upload-area w-100 h-100 d-flex justify-content-center align-items-center">
                                {!isUploading ? (
                                  <>
                                    <label
                                      htmlFor="file-upload-btn"
                                      className="upload-icon d-flex flex-column align-items-center"
                                    >
                                      <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                      <h5 className="my-1">
                                        Upload your{" "}
                                        {localStorage.getItem(
                                          "userdocumentlabel",
                                        )
                                          ? `${localStorage.getItem("userdocumentlabel").toLowerCase() || "project"}`
                                          : "project"}{" "}
                                        here
                                      </h5>
                                      <a className="fs-6">Browse files</a>
                                      <p className="fs-6 mt-2 mb-0">
                                        {" "}
                                        Kindly ensure that your PDF or ZIP file
                                        does not exceed{" "}
                                        <span className="fw-semibold">
                                          {MAX_FILE_SIZE_MB}
                                        </span>
                                        <br className="d-none d-lg-block" /> in
                                        size, You can add multiple files.
                                      </p>
                                    </label>
                                    <input
                                      type="file"
                                      id="file-upload-btn"
                                      className="file-input"
                                      // accept="application/pdf, application/zip"
                                      accept="application/pdf, application/zip, application/x-zip-compressed"
                                      onChange={handleFileInputChange}
                                      ref={fileInputRef}
                                      multiple
                                    />
                                  </>
                                ) : (
                                  <div className="upload-progress-container mt-2">
                                    <div
                                      className="progress"
                                      style={{ width: "100%", height: "13px" }}
                                    >
                                      <div
                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                        role="progressbar"
                                        style={{
                                          width: `${uploadProgress}%`,
                                          height: "10px",
                                        }}
                                        aria-valuenow={uploadProgress}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                      >
                                        {uploadProgress}%
                                      </div>
                                    </div>
                                    <p>Uploading... {uploadProgress}%</p>
                                  </div>
                                )}
                              </div>
                              {/* <div className="d-flex justify-content-between"><div className="text-end p-2" style={{ margin: 0, fontSize: 'smaller' }}>
                          *Kindly ensure that your PDF or ZIP file does not exceed {MAX_FILE_SIZE_MB} MB in size, You can add multiple files.
                        </div></div> */}
                            </>
                          )}
                        </>
                      )}

                      {/* {(fileUploaded && selectedFiles) && ( */}
                      <UploadSteps
                        isVisible={fileUploaded && selectedFiles}
                        step={step}
                        messagesTyping={messagesTyping}
                        onComplete={onComplete}
                        nextStep={nextStep}
                        setStep={setStep}
                        activateTransition={activateTransition}
                        getFirstLetter={getFirstLetter}
                        handleRomove={handleRomove}
                        fileName={fileName}
                        uploadAgents={uploadAgents}
                        serviceData={serviceData}
                        setUploadAgents={setUploadAgents}
                        toggleSummaryAgent={toggleSummaryAgent}
                        toggleAssistantAgent={toggleAssistantAgent}
                        toggleAdditionalFeatures={toggleAdditionalFeatures}
                        handleUpload={handleUpload}
                        isloading={isloading}
                        selectedFiles={selectedFiles}
                        handleFileInputChange={handleFileInputChange}
                        MAX_PDF_PAGES={MAX_PDF_PAGES}
                        MAX_FILE_SIZE_MB={MAX_FILE_SIZE_MB}
                        uploadProgress={uploadProgress}
                        isUploading={isUploading}
                        isvalidating={isvalidating}
                        removingFileIndex={removingFileIndex}
                        agentPrompts={agentPrompts}
                        setAgentPrompts={handleAgentPromptsChange}
                        dateOfInjury={dateOfInjury}
                        setDateOfInjury={setDateOfInjury}
                      />
                      {/*                      
                      
                    )} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default Upload;